export default function getMedals() {
    return new Promise((resolve, reject) => {
        fetch('https://russian.rt.com/olympic-json/api_medal', {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        }).then(res => res.json(res)
        ).then(json => resolve(json)
        ).catch(err => reject(err));
    });
}



// WEBPACK FOOTER //
// ./src/api/medals.js